module.exports = __webpack_public_path__ + "img/logo-notification.b842f621.png";